<template>
    <b-row>
        <b-col md="8" cols="12">
            <b-input-group prepend="Tampilkan" class="align-items-center">
                <b-form-select v-model="show" @change="$emit('limit-change', show)" :options="options" style="max-width: 60px" />
                <div class="ml-2 my-2">{{ totalViewText }}</div>
            </b-input-group>
        </b-col>
        <b-col md="4" cols="12">
            <b-pagination class="mb-0" align="right"
                v-model="currentPage"
                :totalRows="totalRows"
                :per-page="show"
            />
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'page-sizer',
    props: {
        totalRows: { type: Number, required: true },
        options: { type: Array, required: true },
        page: { type: Number, required: true }
    },
    data() {
        return {

            totalViewText: "",
            show: 10,
            currentPage: this.page

        }
    },
    methods: {

        recalculate() {

            let pg = this.currentPage - 1

            let prev = pg * this.show + 1
            let limit = pg * this.show + this.show
            if (limit > this.totalRows) limit = this.totalRows

            this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"

        }

    },
    watch: {

        totalRows(newVal) {
            this.recalculate()
        },

        options(newVal) {
            this.recalculate()
        },

        currentPage(newVal) {
            this.recalculate()
            this.$emit('page-change', newVal)
        },

        show(newVal) {
            this.recalculate()
        },

        page(newVal) {
            this.currentPage = newVal
        }

    },
    created() {
        this.recalculate()
    }
}
</script>
